import { JsonObject } from '../helpers';
import { PrivateModelModel } from '../models/private-model.model';
import { AuthProvider } from './auth.service';
import { get } from './sp-api.service';

export type PrivateModelSettings = {
  defaultPrivateModelId: string;
  availablePrivateModels: PrivateModelModel[];
};

export const getPrivateModelConfig = async (): Promise<PrivateModelSettings> => {
  const response = await get(`/models/private-models/user/${AuthProvider.spUserId}`);

  const { defaultPrivateModel, availablePrivateModels } = (response || {}) as {
    defaultPrivateModel: JsonObject | null;
    availablePrivateModels: JsonObject[];
  };

  return {
    defaultPrivateModelId: (defaultPrivateModel?.id as string) || '',
    availablePrivateModels: (availablePrivateModels || []).map(
      (data) => new PrivateModelModel(data)
    ),
  };
};
